export const messages = {
  en: {
    printContract: {
      title: 'Contract Print',
      print: 'Print',
      close: 'Close',
      noTemplate: 'This contract does not have a template set, please set it in the contract template under the contract type'
    }
  },
  zh: {
    printContract: {
      title: '合同打印',
      print: '打印',
      close: '关闭',
noTemplate: '此合同未设置合同模板，请到合同类型下的合同模板中设置'
    }
  },
  'zh-TW': {
    printContract: {
      title: '合同列印',
      print: '列印',
      close: '關閉',
      noTemplate: '此合同未設置合同模板，請到合同類型下的合同模板中設置'
    }
  }
}